import { useMutation } from '@tanstack/react-query';

import {
  type Calendar_UpdateCalendarBellTimesInput,
  gqlClient,
  graphql,
  queryClient,
  resolveBackendError,
} from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { calendarKeys } from './keys';

const updateCalendarBellTimes = graphql(/* GraphQL */ `
  mutation calendar_updateCalendarBellTimes($input: Calendar_UpdateCalendarBellTimesInput!) {
    calendar_updateCalendarBellTimes(input: $input) {
      success
    }
  }
`);

export function useUpdateCalendarBellTimes() {
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationFn: async (input: Calendar_UpdateCalendarBellTimesInput) =>
      gqlClient.request(updateCalendarBellTimes, { input }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: calendarKeys.all });
      toast.success(t('common:snackbarMessages.updateSuccess'));
    },
    onError: async (error: unknown) => {
      const backendDescription = await resolveBackendError(error);

      const description = backendDescription?.replace(/\..*/, '');
      toast.error(t('common:snackbarMessages.errorFailed'), { description });
    },
  });
}
